import "core-js/modules/es.function.name";
import "core-js/modules/es.object.assign";

/*
 * Copyright (c) 2018 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
 *
 *Description:
*/
import get from './get';
import patch from './patch';
import post from './post';
import fireAndForget from './fire-and-forget';
var defaultNetworkAPI = {
  get: get,
  patch: patch,
  post: post,
  fireAndForget: fireAndForget,
  getJSON: get,
  postForm: post,
  postData: post
};
var networkAPI = Object.assign({}, defaultNetworkAPI);
export var registerNetworkAPI = function registerNetworkAPI(_ref) {
  var name = _ref.name,
      api = _ref.api;
  networkAPI[name] = api;
};
export default (function () {
  return networkAPI;
});